import CalendarEventPopup from "../calendarEventPopup/CalendarEventPopup";


const ContentTemplate = (props) => {
   return <CalendarEventPopup {...props} calendarType="FullCalendar"/>
};

const HeaderTemplate = () => {
    return <div />
};

const FooterTemplate = () => {
    return <div />
};

const quickInfoTemplates = {
    header: HeaderTemplate,
    content: ContentTemplate,
    footer: FooterTemplate
};

export default quickInfoTemplates;